import { render, staticRenderFns } from "./ShowDataList.vue?vue&type=template&id=00c533de&scoped=true&"
import script from "./ShowDataList.vue?vue&type=script&lang=js&"
export * from "./ShowDataList.vue?vue&type=script&lang=js&"
import style0 from "./ShowDataList.vue?vue&type=style&index=0&id=00c533de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c533de",
  null
  
)

export default component.exports